import { createStore } from '@pidedirecto/ui/hooks';
import moment from 'moment-timezone';
import { DeliveryStatus, DeliveryStatuses } from 'src/constants/DeliveryStatus';
import { OrderStatus, OrderStatuses } from 'src/constants/OrderStatus';
import { TakeAwayOrderStatus, TakeAwayOrderStatuses } from 'src/constants/TakeAwayOrderStatus';
import { isTableViewInOrdersPageInLocalStorage } from 'src/localStorage/isTableViewInOrdersPageInLocalStorage';
import { setIsTableViewInOrdersPageInLocalStorage } from 'src/localStorage/setIsTableViewInOrdersPageInLocalStorage';
import { OrderPageTab, OrderPageTabs } from 'src/modules/order/constants/OrderPageTab';

export const [useOrderPageStore, useOrderPageActions] = createStore<OrderPageState, OrderPageActions>({
    initialState: {
        isTableView: isTableViewInOrdersPageInLocalStorage(),
        currentTab: OrderPageTabs.ALL,
        orderStatuses: [OrderStatuses.ACCEPTED, OrderStatuses.COMPLETE, OrderStatuses.REJECTED, OrderStatuses.CANCELLED, OrderStatuses.RETURNED],
        deliveryStatuses: [DeliveryStatuses.REQUESTED, DeliveryStatuses.ACCEPTED, DeliveryStatuses.DELIVERED, DeliveryStatuses.RETURNED, DeliveryStatuses.REJECTED, DeliveryStatuses.CANCELLED],
        takeAwayOrderStatuses: [
            TakeAwayOrderStatuses.ACCEPTED,
            TakeAwayOrderStatuses.READY_FOR_PICK_UP,
            TakeAwayOrderStatuses.COMPLETED,
            TakeAwayOrderStatuses.CANCELLED,
            TakeAwayOrderStatuses.REJECTED,
        ],
        eatHereOrderStatuses: [OrderStatuses.PENDING, OrderStatuses.COMPLETE, OrderStatuses.REJECTED, OrderStatuses.CANCELLED],
        roomServiceOrderStatuses: [OrderStatuses.NEW, OrderStatuses.ACCEPTED, OrderStatuses.COMPLETE, OrderStatuses.REJECTED, OrderStatuses.CANCELLED],
        from: moment().startOf('day').toDate(),
        to: moment().endOf('day').toDate(),
        query: '',
    },
    actions: {
        showOrdersTableView: (state) => {
            state.isTableView = true;
            setIsTableViewInOrdersPageInLocalStorage(true);
        },
        showOrdersCardView: (state) => {
            state.isTableView = false;
            setIsTableViewInOrdersPageInLocalStorage(false);
        },
        changeFromDateFilter: (state, from) => {
            state.isTableView = false;
            state.from = from;
        },
        changeToDateFilter: (state, to) => {
            state.isTableView = false;
            state.to = to;
        },
        changeOrderStatuses: (state, orderStatuses) => {
            state.isTableView = false;
            state.orderStatuses = orderStatuses;
        },
        changeDeliveryStatuses: (state, deliveryStatuses) => {
            state.isTableView = false;
            state.deliveryStatuses = deliveryStatuses;
        },
        changeTakeAwayOrderStatuses: (state, takeAwayOrderStatuses) => {
            state.isTableView = false;
            state.takeAwayOrderStatuses = takeAwayOrderStatuses;
        },
        changeEatHereOrderStatuses: (state, eatHereOrderStatuses) => {
            state.isTableView = false;
            state.eatHereOrderStatuses = eatHereOrderStatuses;
        },
        changeRoomServiceOrderStatuses: (state, roomServiceOrderStatuses) => {
            state.isTableView = false;
            state.roomServiceOrderStatuses = roomServiceOrderStatuses;
        },
        changeOrderPageTab: (state, currentTab) => {
            state.isTableView = false;
            state.currentTab = currentTab;
        },
        searchOrders: (state, query) => {
            state.isTableView = false;
            state.query = query;
        },
    },
});

export type OrderPageState = {
    isTableView: boolean;
    currentTab: OrderPageTab;
    orderStatuses: Array<OrderStatus>;
    deliveryStatuses: Array<DeliveryStatus>;
    takeAwayOrderStatuses: Array<TakeAwayOrderStatus>;
    eatHereOrderStatuses: Array<OrderStatus>;
    roomServiceOrderStatuses: Array<OrderStatus>;
    from: Date;
    to: Date;
    query: string;
};

export type OrderPageActions = {
    showOrdersTableView: () => void;
    showOrdersCardView: () => void;
    changeFromDateFilter: (from: Date) => void;
    changeToDateFilter: (to: Date) => void;
    changeOrderStatuses: (orderStatuses: Array<OrderStatus>) => void;
    changeDeliveryStatuses: (deliveryStatuses: Array<DeliveryStatus>) => void;
    changeTakeAwayOrderStatuses: (orderStatuses: Array<TakeAwayOrderStatus>) => void;
    changeEatHereOrderStatuses: (orderStatuses: Array<OrderStatus>) => void;
    changeRoomServiceOrderStatuses: (orderStatuses: Array<OrderStatus>) => void;
    changeOrderPageTab: (orderPageTab: OrderPageTab) => void;
    searchOrders: (query: string) => void;
};
